import AppPermission from "./appPermission";

export default AppPermission;
